export const siteName = "古古漫画网";

export const navLinks = [
  { label: "首页", href: "#hero" },
  { label: "热门推荐", href: "#cards" },
  { label: "常见问题", href: "#faq" },
  { label: "读者热评", href: "#comments" },
  { label: "平台特色", href: "#features" },
  { label: "漫画分类", href: "#index" },
];

export const heroData = {
  tags: ["国漫", "日漫", "韩漫"],
  h1: "古古漫画网 - 追更连载，热门漫画每日更新",
  slogan: "免费全集下拉式阅读，人气漫画一网打尽",
  description: "古古漫画网专注国内外热门漫画连载追更服务，覆盖国漫、日漫、韩漫三大板块，每日同步更新最新话数。无论是热血少年漫、悬疑推理漫还是恋爱甜宠漫，这里都能满足你的阅读需求。本站采用下拉式阅读模式，一次加载即可畅快连续阅读，无需频繁翻页，让你的追更体验更加流畅沉浸。",
  stats: [
    { label: "日均更新", value: "200+" },
    { label: "收录漫画", value: "10,000+" },
    { label: "在读读者", value: "500万+" },
  ],
  ctaPrimary: { label: "开始追更", href: "#cards" },
  ctaSecondary: { label: "查看榜单", href: "#ranking" },
};

export const aboutData = {
  title: "关于古古漫画网",
  content: "古古漫画网成立于2019年，是国内领先的免费漫画在线阅读平台。我们与多家正版漫画平台合作，致力于为广大漫迷提供海量优质的漫画资源。平台支持PC端和移动端阅读，采用先进的下拉式阅读技术，让每一话漫画都能无缝衔接。我们的编辑团队每日筛选最新最热的连载漫画，确保读者不错过任何一部精彩作品。从经典神作到新番速递，古古漫画网陪伴你的每一个阅读时光。",
};

export const faqData = {
  title: "常见问题",
  items: [
    { q: "古古漫画网的漫画是免费的吗？", a: "是的，古古漫画网所有漫画均免费提供全集下拉式阅读，无需注册登录即可畅读所有内容。" },
    { q: "漫画多久更新一次？", a: "热门连载漫画每日同步更新，具体更新时间以各漫画的实际连载节奏为准，通常在各大平台首发后24小时内同步。" },
    { q: "支持手机阅读吗？", a: "完全支持。古古漫画网采用响应式设计，在手机、平板和电脑上都能获得流畅的下拉式阅读体验。我们还提供移动端专属优化，加载更快更省流量。" },
    { q: "国漫、日漫和韩漫都有吗？", a: "三大板块我们全部覆盖。国漫专区收录国内各大平台热门连载，日漫区精选Jump系、讲谈社等经典，韩漫区则聚集了当下最火的条漫作品。" },
    { q: "如何找到我想看的漫画？", a: "你可以通过顶部分类导航浏览不同题材，也可以使用首页的搜索功能直接查找漫画名称。更新榜单和热门推荐也能帮你快速发现优质漫画。" },
    { q: "遇到图片加载不出来怎么办？", a: "建议刷新页面重试。如果问题持续，可能是网络波动导致，切换网络环境后通常能恢复正常。我们也在持续优化服务器稳定性。" },
  ],
};

export const mediaData = {
  title: "精选推荐",
  items: [
    {
      title: "《斗破苍穹》年番热播",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20Doupo%20Cangqiong%20epic%20fantasy%20battle%20scene%20with%20martial%20arts%20characters%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20red%20tones%2C%20dynamic%20composition%2C%20manga%20style%20artwork%2C%20cinematic%20illustration%2C%20intense%20atmosphere%2C%20professional%20digital%20art%20with%20clean%20lines%20and%20vivid%20colors%2C%20full%20body%20character%20in%20action%20pose&width=640&height=360&seq=media-comic-01&orientation=landscape",
      tag: "国漫·热血",
      desc: "萧炎踏上加玛帝国巅峰之路，年度重磅连载持续更新中",
    },
    {
      title: "《咒术回战》涩谷事变篇",
      cover: "https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20style%20dark%20fantasy%20manga%20illustration%2C%20supernatural%20battle%20scene%20with%20cursed%20energy%20effects%2C%20dramatic%20urban%20night%20setting%2C%20warm%20dark%20tones%20with%20crimson%20accents%2C%20dynamic%20action%20composition%2C%20professional%20Japanese%20manga%20art%20style%2C%20intense%20atmosphere%2C%20detailed%20character%20art&width=640&height=360&seq=media-comic-02&orientation=landscape",
      tag: "日漫·战斗",
      desc: "五条悟封印后的世界，虎杖一行人面临前所未有的危机",
    },
    {
      title: "《我独自升级》第二季",
      cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20Solo%20Leveling%20style%20dark%20fantasy%20illustration%2C%20shadow%20monarch%20character%20with%20glowing%20eyes%2C%20epic%20dark%20army%20behind%2C%20dramatic%20composition%2C%20warm%20dark%20tones%20with%20amber%20highlights%2C%20professional%20digital%20webtoon%20art%20style%2C%20clean%20rendering%2C%20powerful%20atmosphere&width=640&height=360&seq=media-comic-03&orientation=landscape",
      tag: "韩漫·奇幻",
      desc: "成振宇暗影军团集结，S级猎人篇章正式开启",
    },
    {
      title: "《一人之下》唐门篇",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20Yi%20Ren%20Zhi%20Xia%20style%20martial%20arts%20illustration%2C%20Taoist%20supernatural%20battle%20in%20ancient%20Chinese%20setting%2C%20dynamic%20fight%20scene%20with%20energy%20effects%2C%20warm%20earth%20tones%20with%20golden%20accents%2C%20professional%20manhua%20art%20style%2C%20detailed%20traditional%20clothing%2C%20cinematic%20composition&width=640&height=360&seq=media-comic-04&orientation=landscape",
      tag: "国漫·异能",
      desc: "张楚岚深入唐门秘境，甲申之乱的真相逐渐浮出水面",
    },
    {
      title: "《间谍过家家》日常篇",
      cover: "https://readdy.ai/api/search-image?query=Spy%20Family%20style%20heartwarming%20manga%20illustration%2C%20family%20scene%20with%20spy%20father%20assassin%20mother%20and%20telepath%20daughter%2C%20cozy%20European%20style%20home%20setting%2C%20warm%20golden%20lighting%2C%20wholesome%20atmosphere%2C%20professional%20Japanese%20manga%20art%20style%2C%20gentle%20color%20palette&width=640&height=360&seq=media-comic-05&orientation=landscape",
      tag: "日漫·温馨",
      desc: "福杰一家的爆笑日常，劳埃德和阿尼亚的父女日常萌翻全场",
    },
  ],
};

export const carouselData = {
  title: "编辑力荐",
  items: [
    {
      title: "《镖人》",
      subtitle: "刀光剑影中的江湖传奇",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20Biao%20Ren%20style%20ancient%20Chinese%20martial%20arts%20illustration%2C%20lone%20warrior%20in%20desert%20landscape%2C%20dramatic%20sunset%20lighting%2C%20warm%20golden%20and%20crimson%20tones%2C%20epic%20cinematic%20composition%2C%20detailed%20traditional%20armor%2C%20professional%20manhua%20art%20style%2C%20majestic%20atmosphere&width=800&height=480&seq=carousel-01&orientation=landscape",
      tag: "国漫巅峰",
      desc: "许先哲力作，硬派武侠漫画的标杆，大漠孤烟中的刀客传奇",
    },
    {
      title: "《葬送的芙莉莲》",
      subtitle: "勇者死后，魔法使的旅程才刚开始",
      cover: "https://readdy.ai/api/search-image?query=Frieren%20Beyond%20Journey%20End%20style%20fantasy%20manga%20illustration%2C%20elf%20mage%20traveling%20through%20peaceful%20landscape%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20gentle%20color%20palette%2C%20professional%20Japanese%20manga%20art%20style%2C%20emotional%20and%20beautiful%20composition&width=800&height=480&seq=carousel-02&orientation=landscape",
      tag: "日漫神作",
      desc: "治愈与感动交织的旅程，关于时间、生命与羁绊的动人故事",
    },
    {
      title: "《全知读者视角》",
      subtitle: "当小说变成现实，只有他知道结局",
      cover: "https://readdy.ai/api/search-image?query=Omniscient%20Reader%20Viewpoint%20style%20Korean%20webtoon%20illustration%2C%20apocalyptic%20urban%20scene%20with%20protagonist%20in%20coat%2C%20dramatic%20composition%2C%20warm%20dark%20tones%20with%20amber%20accents%2C%20professional%20webtoon%20art%20style%2C%20cinematic%20lighting%2C%20intense%20atmosphere&width=800&height=480&seq=carousel-03&orientation=landscape",
      tag: "韩漫神作",
      desc: "独读者面对末日降临，用阅读积累的知识改写所有人的命运",
    },
    {
      title: "《镇魂街》",
      subtitle: "镇守亡灵之街，守护两界和平",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20Zhen%20Hun%20Jie%20style%20urban%20fantasy%20illustration%2C%20guardian%20spirit%20warrior%20in%20modern%20city%2C%20dramatic%20composition%2C%20warm%20orange%20and%20dark%20tones%2C%20dynamic%20action%20pose%2C%20professional%20manhua%20art%20style%2C%20epic%20atmosphere&width=800&height=480&seq=carousel-04&orientation=landscape",
      tag: "国漫经典",
      desc: "曹操后人守护亡灵世界，人灵共存的热血冒险长篇连载",
    },
    {
      title: "《蓝色监狱》",
      subtitle: "300名前锋，只为诞生世界第一",
      cover: "https://readdy.ai/api/search-image?query=Blue%20Lock%20style%20sports%20manga%20illustration%2C%20intense%20soccer%20match%20scene%20with%20dynamic%20movement%2C%20dramatic%20stadium%20lighting%2C%20warm%20energetic%20tones%2C%20professional%20Japanese%20manga%20art%20style%2C%20powerful%20athletic%20composition%2C%20competitive%20atmosphere&width=800&height=480&seq=carousel-05&orientation=landscape",
      tag: "日漫·运动",
      desc: "残酷足球淘汰赛，洁世一能否在这场生存战中脱颖而出",
    },
  ],
};

export const cardsData = {
  title: "热门推荐",
  items: [
    {
      title: "《完美世界》",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20Perfect%20World%20style%20fantasy%20illustration%2C%20young%20cultivator%20in%20ancient%20Chinese%20mythological%20setting%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20red%20tones%2C%20epic%20composition%2C%20professional%20manhua%20art%20style%2C%20detailed%20martial%20arts%20pose&width=400&height=560&seq=card-01&orientation=portrait",
      tag: "国漫·玄幻",
      chapter: "更新至 第328话",
      desc: "石昊独断万古之路，辰东经典IP改编",
    },
    {
      title: "《鬼灭之刃》",
      cover: "https://readdy.ai/api/search-image?query=Demon%20Slayer%20style%20Japanese%20manga%20illustration%2C%20swordsman%20with%20water%20breathing%20technique%2C%20dynamic%20action%20pose%2C%20warm%20dark%20tones%20with%20crimson%20accents%2C%20professional%20manga%20art%20style%2C%20dramatic%20Japanese%20traditional%20aesthetic&width=400&height=560&seq=card-02&orientation=portrait",
      tag: "日漫·热血",
      chapter: "已完结 全205话",
      desc: "灶门炭治郎的灭鬼之旅，现象级少年漫",
    },
    {
      title: "《女神降临》",
      cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20True%20Beauty%20style%20romance%20illustration%2C%20beautiful%20female%20protagonist%20in%20modern%20fashion%2C%20soft%20warm%20lighting%2C%20gentle%20pastel%20tones%2C%20professional%20webtoon%20art%20style%2C%20elegant%20romantic%20atmosphere&width=400&height=560&seq=card-03&orientation=portrait",
      tag: "韩漫·恋爱",
      chapter: "更新至 第247话",
      desc: "化妆变脸女神的校园恋爱，甜蜜又爆笑",
    },
    {
      title: "《大王饶命》",
      cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20fantasy%20illustration%2C%20young%20modern%20cultivator%20with%20humorous%20expression%2C%20urban%20fantasy%20setting%2C%20bright%20warm%20lighting%2C%20playful%20atmosphere%2C%20professional%20manhua%20art%20style%2C%20clean%20modern%20rendering&width=400&height=560&seq=card-04&orientation=portrait",
      tag: "国漫·搞笑",
      chapter: "更新至 第412话",
      desc: "灵气复苏时代，吕树的毒舌吐槽修仙路",
    },
    {
      title: "《链锯人》",
      cover: "https://readdy.ai/api/search-image?query=Chainsaw%20Man%20style%20dark%20manga%20illustration%2C%20devil%20hunter%20protagonist%20with%20chainsaw%20weapons%2C%20urban%20night%20setting%2C%20warm%20dark%20tones%20with%20red%20accents%2C%20gritty%20professional%20manga%20art%20style%2C%20intense%20and%20raw%20composition&width=400&height=560&seq=card-05&orientation=portrait",
      tag: "日漫·黑暗",
      chapter: "第二部 更新至 第82话",
      desc: "藤本树癫狂之作，电次与恶魔共舞的世界",
    },
  ],
};

export const topicsData = {
  title: "热门话题",
  items: [
    { name: "玄幻修仙", count: "128万讨论" },
    { name: "热血战斗", count: "96万讨论" },
    { name: "甜宠恋爱", count: "83万讨论" },
    { name: "悬疑推理", count: "67万讨论" },
    { name: "异世界转生", count: "55万讨论" },
    { name: "系统流", count: "48万讨论" },
    { name: "都市异能", count: "42万讨论" },
    { name: "武侠江湖", count: "38万讨论" },
    { name: "末日生存", count: "33万讨论" },
    { name: "搞笑日常", count: "29万讨论" },
    { name: "恐怖灵异", count: "25万讨论" },
  ],
};

export const featuresData = {
  title: "平台特色",
  items: [
    {
      icon: "ri-book-open-line",
      title: "下拉式阅读",
      desc: "独创下拉连续阅读模式，一话到底无需翻页，沉浸式追更体验，让每次阅读都畅快淋漓。支持自动记忆阅读进度。",
    },
    {
      icon: "ri-flashlight-line",
      title: "每日同步更新",
      desc: "编辑团队全天候追踪各大漫画平台最新动态，热门连载24小时内同步更新，让你追更快人一步，永不错过精彩剧情。",
    },
    {
      icon: "ri-smartphone-line",
      title: "全平台适配",
      desc: "电脑、平板、手机完美适配，无论在家还是出行都能畅快追漫。移动端特别优化，低流量消耗也能流畅阅读。",
    },
  ],
};

export const rankingData = {
  title: "人气榜单",
  items: [
    { rank: 1, title: "《斗破苍穹》", tag: "国漫·玄幻", heat: "本周热度 986万" },
    { rank: 2, title: "《咒术回战》", tag: "日漫·战斗", heat: "本周热度 872万" },
    { rank: 3, title: "《我独自升级》", tag: "韩漫·奇幻", heat: "本周热度 765万" },
    { rank: 4, title: "《完美世界》", tag: "国漫·玄幻", heat: "本周热度 698万" },
    { rank: 5, title: "《葬送的芙莉莲》", tag: "日漫·治愈", heat: "本周热度 621万" },
    { rank: 6, title: "《镖人》", tag: "国漫·武侠", heat: "本周热度 554万" },
  ],
};

export const indexData = {
  title: "漫画分类",
  items: [
    { icon: "ri-fire-line", name: "热血", desc: "燃到爆炸的战斗冒险" },
    { icon: "ri-heart-line", name: "恋爱", desc: "甜到心里的浪漫故事" },
    { icon: "ri-ghost-line", name: "悬疑", desc: "烧脑推理与反转" },
    { icon: "ri-landscape-line", name: "奇幻", desc: "异世界的无限想象" },
    { icon: "ri-sword-line", name: "武侠", desc: "江湖快意恩仇录" },
    { icon: "ri-emotion-laugh-line", name: "搞笑", desc: "承包你的每日笑点" },
    { icon: "ri-building-line", name: "都市", desc: "现代生活的奇幻冒险" },
    { icon: "ri-moon-line", name: "恐怖", desc: "胆小慎入的惊悚之作" },
  ],
};

export const commentsData = {
  title: "读者热评",
  items: [
    {
      avatar: "https://readdy.ai/api/search-image?query=anime%20style%20young%20male%20avatar%20portrait%2C%20warm%20expression%2C%20simple%20background%2C%20clean%20illustration%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-01&orientation=squarish",
      name: "追漫狂人阿强",
      time: "2小时前",
      content: "古古漫画网的下拉式阅读真的太爽了！终于不用一页一页点，一滑到底追完一整话，《斗破苍穹》最新话看得我热血沸腾，萧炎终于要突破斗尊了！",
      comic: "《斗破苍穹》",
    },
    {
      avatar: "https://readdy.ai/api/search-image?query=anime%20style%20young%20female%20avatar%20portrait%2C%20gentle%20smile%2C%20simple%20background%2C%20clean%20illustration%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-02&orientation=squarish",
      name: "甜甜圈少女",
      time: "5小时前",
      content: "每天地铁通勤就靠古古漫画网续命了，移动端阅读体验超赞！《女神降临》真的太好磕了，修浩和珠京什么时候在一起啊急死我了！",
      comic: "《女神降临》",
    },
    {
      avatar: "https://readdy.ai/api/search-image?query=anime%20style%20teen%20male%20avatar%20portrait%2C%20cool%20expression%2C%20simple%20background%2C%20clean%20illustration%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish",
      name: "二次元猎手",
      time: "8小时前",
      content: "韩漫区最近更新的《全知读者视角》质量太高了，剧情节奏紧凑得不行。古古漫画网的编辑选品真的有一手，推荐的全是精品！",
      comic: "《全知读者视角》",
    },
    {
      avatar: "https://readdy.ai/api/search-image?query=anime%20style%20young%20female%20avatar%20portrait%2C%20warm%20smile%2C%20simple%20background%2C%20clean%20illustration%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-04&orientation=squarish",
      name: "深夜追更人",
      time: "12小时前",
      content: "国漫区《镖人》真的封神了！每话都像在看电影一样，画工精细到每一格都能当壁纸。感谢古古漫画网让我免费追到这么高质量的作品！",
      comic: "《镖人》",
    },
  ],
};

export const contactData = {
  title: "联系我们",
  content: "如果你有任何关于漫画推荐、版权合作或平台使用的疑问，欢迎随时与我们联系。古古漫画网团队将竭诚为你服务。",
  email: "contact@gugumanhua.com",
  qq: "读者交流群：888888888",
};

export const appData = {
  title: "随时随地追更",
  subtitle: "扫码下载古古漫画网移动客户端",
  features: ["下拉式阅读", "离线缓存", "更新推送", "夜间模式"],
  qrCode: "https://readdy.ai/api/search-image?query=modern%20QR%20code%20design%20with%20minimal%20style%2C%20clean%20black%20and%20white%20pattern%2C%20simple%20graphic%2C%20digital%20style&width=240&height=240&seq=qr-code-app&orientation=squarish",
};

export const updatesData = {
  title: "最近更新",
  items: [
    { time: "07-28 14:30", title: "《斗破苍穹》第328话 - 萧炎VS魂殿护法", type: "更新" },
    { time: "07-28 12:15", title: "《咒术回战》第256话 - 宿傩的领域展开", type: "更新" },
    { time: "07-28 10:00", title: "《我独自升级》第189话 - 暗影军团出击", type: "更新" },
    { time: "07-28 08:45", title: "《完美世界》第412话 - 石昊渡劫", type: "更新" },
    { time: "07-28 07:30", title: "《女神降临》第247话 - 修浩的告白", type: "更新" },
    { time: "07-28 06:00", title: "古古漫画网服务器全面升级完成", type: "公告" },
    { time: "07-27 22:00", title: "《一人之下》唐门篇第78话上线", type: "更新" },
    { time: "07-27 18:30", title: "新增韩漫专区《全知读者视角》全卷收录", type: "上新" },
    { time: "07-27 15:00", title: "《大王饶命》第496话 - 吕树的终极吐槽", type: "更新" },
  ],
};

export const footerData = {
  intro: "古古漫画网是国内领先的免费漫画在线阅读平台，每日同步更新热门国漫、日漫、韩漫，提供全集下拉式阅读体验。追更连载、人气漫画一网打尽，让阅读变得更简单。",
  links: [
    { label: "关于我们", href: "#about" },
    { label: "常见问题", href: "#faq" },
    { label: "热门推荐", href: "#cards" },
    { label: "人气榜单", href: "#ranking" },
    { label: "漫画分类", href: "#index" },
    { label: "联系我们", href: "#contact" },
  ],
  copyright: "© 2025 古古漫画网 Gugumanhua.com 版权所有",
};